// Pricing tiers discount either a percentage of each eligible unit price
// (`percent_off`, the original mode) or a flat amount off the order
// (`amount_off`). These helpers read either shape the storefront sees:
// V1 JSON:API resources (values under `attributes`, money as `{ cents }`)
// and V2 snapshot hashes (flat values, money as integer cents).

const values = (tier) => (tier && tier.attributes) || tier || {}

const amountOffCents = (tier) => {
  const amount = values(tier).amount_off
  if (amount && typeof amount === 'object') return Number(amount.cents) || 0
  return Number(amount) || 0
}

const isAmountOff = (tier) => values(tier).discount_type === 'amount_off'

const rateOff = (tier) => Number(values(tier).rate_off) || 0

// The size of the discount in its own unit: a rate for percent tiers, cents
// for flat tiers. Only comparable between tiers of the same type.
const discountValue = (tier) => (isAmountOff(tier) ? amountOffCents(tier) : rateOff(tier))

export const tierHasDiscount = (tier) => discountValue(tier) > 0

export const tierDiscountLabel = (tier) => {
  const attrs = values(tier)
  if (attrs.discount_label) return attrs.discount_label
  if (attrs.percentage_off) return attrs.percentage_off
  return `${Math.round(rateOff(tier) * 100)}%`
}

// Whether moving from `previous` to `next` is worth celebrating (flash the
// bar, toast the unlock). Same type: a bigger discount, or the same discount
// gaining free shipping. Different types can't be compared without the cart,
// so any move into a discount counts.
export const isUpgradedTier = (next, previous) => {
  if (!tierHasDiscount(next)) return false
  if (isAmountOff(next) !== isAmountOff(previous)) return true
  const nextValue = discountValue(next)
  const previousValue = discountValue(previous)
  return nextValue > previousValue || (nextValue === previousValue && !!values(next).free_shipping)
}
